<template>
    <div class="container">
        <b-modal :model-value="modEditCentroCostos" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <div class="text-center">
                {{ labels.title }} 
            </div>
            <div class="">
                <!-- <pre>{{ Infocc }}</pre> -->
                <b-row class="">
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.centroCosto}}</h5> 
                    </b-col>
                    <b-col cols="1"></b-col>
                    <b-col cols="6">
                        <div v-for="cc in centroCostoFiltrado" :key="cc.id"> 
                            <h6>{{ cc?.descripcion }} ({{ cc?.centro_costo }})</h6> 
                        </div>
                    </b-col>
                </b-row>
                <b-row class="text-center">
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.porcentaje}}</h5> 
                    </b-col>
                    <b-col cols="1"></b-col>
                    <b-col cols="6">
                        <input type="number" :items="Infocc?.porcentaje" class="form-control"> 
                    </b-col>
                </b-row>
                <div class="mt-1">
                    <b-col cols="7" class="text-left">
                        <b-button class="md-accent" @click="eliminaRegistro">{{ labels.deletePorcentajecc }}</b-button> 
                    </b-col>
                    <b-col cols="3">
                        <b-button class="md-primary" @click="aceptaCentroCostos">{{ labels.save }}</b-button> 
                    </b-col>
                    <b-col cols="3">
                        <b-button class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> 
                    </b-col>
                </div>
            </div>
        </b-modal>
        <InacticaItem :InactivaItem="showDelPorcecc" @confirmDelete="deletePorcentajecc" @cierraModal="cierraModalDelet"></InacticaItem>
    </div>
</template>

<script>
import CentroCostos from '../../services/CentroCostos'; 
import ContratoCentroCostos from '../../services/ContratoCentroCostos'; 
import InacticaItem from '../utils/InacticaItem.vue'; 

export default {
    name : 'EditarCentroCosto',
    components: { InacticaItem },
    props:['modEditCentroCostos','numContrato','Infocc'],
    data : () => ({
        listCentroCostos : [],
        showDelPorcecc : false,
        idContrato_cc : ''
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Editar centro de costo',
                    save : 'Guardar',
                    close : 'Cerrar',
                    deletePorcentajecc : 'Eliminar',
                    centroCosto : "Centro Costo",
                    porcentaje : "Porcentaje",
                }
            }else{
                return {
                    title : 'Edit cost center',
                    save : 'Save',
                    close : 'Close',
                    deletePorcentajecc : 'Delete',
                    centroCosto : "Centro Costo",
                    porcentaje : "Porcentaje",
                }
            }
        },
        centroCostoFiltrado() {
            return this.listCentroCostos?.filter( 
                (cc) => cc.centro_costo === this.Infocc.centro_costo 
            );
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        aceptaCentroCostos(){
            // console.log('aceptaCentroCostos'); 
            const info = {
                'numContrato' : this.Infocc.nro_contrato, 
                'vigencia' : this.Infocc.vigencia, 
                'centroCosto' : this.Infocc.centro_costo, 
                'porcentaje' : this.Infocc.porcentaje, 
                'id' : this.Infocc.id, 
                'idUser' : this.$store.state.userId 
            }
            // console.log(info); 

            ContratoCentroCostos.updateContratoCentroCosto(info) 
            .then((res) => { 
                this.$toast.success(res.data.message) 
                this.$emit('reloadTblCntCst',this.Infocc.vigencia) 
            })
            .catch((error) => { 
                if (error.response && error.response.data) { 
                    this.$toast.error(error.response.data.message); 
                }
            })
        },
        eliminaRegistro(){
            this.showDelPorcecc = true 
            this.id_ccContrato = this.Infocc.id 
        },
        cierraModalDelet(){
            this.showDelPorcecc = false 
        },
        deletePorcentajecc(){
            // console.log(this.id_ccContrato); 
            ContratoCentroCostos.deletPorcentajeCentroCosto(this.id_ccContrato) 
            .then((res) => { 
                this.$toast.success(res.data.message) 
                location.reload() 
            })
            .catch((error) => { 
                console.log(error); 
            })
        },
    },
    mounted(){
        CentroCostos.getAllCentroCostos() 
        .then((res) => { 
            this.listCentroCostos = res.data.listCentroCostos 
            // console.log(this.listCentroCostos) 
        })
        .catch((err) => console.log(err)) 
    }
}
</script>

<style>

</style>
